import React from 'react'

import PersonCoverageModal from 'components/PersonCoverageModal'

const GROUP_HEALTH_COVERAGE_DESCRIPTION =
  'We’ll calculate your group health plan pricing based on who you want to cover. Use the checkboxes and click “Save” to make any changes.'

const GroupHealthCoverageModal = (props) => (
  <PersonCoverageModal description={GROUP_HEALTH_COVERAGE_DESCRIPTION} {...props} />
)

GroupHealthCoverageModal.displayName = 'GroupHealthCoverageModal'

export default GroupHealthCoverageModal
